import { render, staticRenderFns } from "./CategoryTrends.vue?vue&type=template&id=5b764838&scoped=true&"
import script from "./CategoryTrends.vue?vue&type=script&lang=js&"
export * from "./CategoryTrends.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTrends.vue?vue&type=style&index=0&id=5b764838&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b764838",
  null
  
)

export default component.exports